import { render, staticRenderFns } from "./FeatureCollectionNewChic.vue?vue&type=template&id=13b5d7be&scoped=true&"
import script from "./FeatureCollectionNewChic.vue?vue&type=script&lang=js&"
export * from "./FeatureCollectionNewChic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5d7be",
  null
  
)

export default component.exports